// extracted by mini-css-extract-plugin
export default {"productWrap":"ProductList_productWrap__jDX3n","productItem":"ProductList_productItem__56CJ+","productPhoto":"ProductList_productPhoto__pORgE"};